<div class="container text-center">
  <div class="row">
    <ng-container *ngIf="loading; else content">
      <!-- Show loading spinner or placeholder content -->
      <div class="col-12">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </ng-container>
    <ng-template #content>
      <!-- Repeat for other cards similarly -->
      
<div class="col-md-6 col-sm-12 custom-card mb-4" *ngFor="let areaType of getAreaTypeKeys()" [ngStyle]="{'padding': '20px'}">
        <div class="card equal-height-card wider-card" (click)="navigateToPage(areaType)" [ngStyle]="{'background-color': getAreaTypeColor(areaType)}">
          <div class="card-body d-flex align-items-center">
            <div class="p-2">
              <img src="assets/img/tv.png" alt="Logo" class="img-fluid" style="width: 100px;">
            </div>
            <div class="d-flex flex-column justify-content-left">
      <h5 class="mb-1" style="color: white;">{{areaType}}</h5>
      <div class="circle-tile-number" style="color: white;">{{ areaTypeCounts[areaType] }}</div>
    </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>